export const RestoreLogRoutes = [
  {
    path: '/common/restore-log',
    name: 'Restore Log',
    meta: {
      title: 'Restore Log',
    },
    component: () => import('../views/common/RestoreLog.vue'),
  },
];

export default RestoreLogRoutes;
